<template>
  <!-- 退费弹框 -->
  <div>
    <custom-dialog v-if="dialogVisible" width="450px" :visible="dialogVisible" contentClass="dialog-content-class"
      @close="dialogVisible = false">
      <div slot="header">
        <div class="header">
          <div class="member-warp">
            <span style="width: 100px;">{{ memberFormInfo.memberName }}</span>
            <span style="width: 60px;">{{ memberFormInfo.sex === '0' ? '男' : (memberFormInfo.sex === '1' ? '女' : '未知')
            }}</span>
            <span style="width: 60px;">{{ memberFormInfo.year }} 岁</span>
            <span style="width: 60px;">{{ memberFormInfo.month }} 月</span>
            <span>{{ memberFormInfo.phone }}</span>
          </div>
        </div>
      </div>

      <div class="content" slot="content">
        <el-table :data="accountList" border @selection-change="handleSelectionChange" max-height="400px">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="充值时间" prop="createTime" align="left"></el-table-column>
          <el-table-column label="充值金额" prop="rechargeAmount" align="right" width="90px"></el-table-column>
          <el-table-column label="充值方式" prop="payWay" align="left" width="90px"
            :formatter="payWayFormatter"></el-table-column>
          <el-table-column :class-name="curAmountStyle" :label-class-name="curAmountLabelStyle" label="剩余本金"
            prop="curAmount" align="right" width="90px"></el-table-column>
        </el-table>
        <div class="footer">
          <div class="footer_total">
            <span>退费合计：</span>
            <span class="footer_total_price">￥{{ computedTotal }}</span>
          </div>
          <div>
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirm">确定</el-button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog v-if="confirmDialogVisible" width="490px" :visible="confirmDialogVisible"
      contentClass="dialog-content-class" title="退费金额及退费方式确认">
      <div class="content" slot="content">
        <el-table :data="multipleSelection" border>
          <el-table-column type="index" label="序号" width="52"></el-table-column>
          <el-table-column label="退费金额" prop="curAmount" width="90px" align="right"></el-table-column>
          <el-table-column label="退费方式" prop="payWay" align="left">
            <template slot-scope="scope">
              <div v-if="scope.row.payWay == '3' && !scope.row.expired">【好码齐】系统原路退还</div>
              <div v-if="scope.row.payWay == '2'">【现金】请退现金</div>
              <div v-if="scope.row.payWay == '3' && scope.row.expired">
                <div>【财务转账】请在企微发起会员充值退款申请</div>
                <div class="tips">好码齐超过90天的金额无法原路退还</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-remark">
          <el-input v-model="remark" maxlength="200" placeholder="请输入退费原因"></el-input>
        </div>
        <div class="footer">
          <div class="footer_total">
            <span>退费合计：</span>
            <span class="footer_total_price">￥{{ computedTotal }}</span>
          </div>
          <div>
            <el-button @click="confirmDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmHandle">确定</el-button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
  </div>
</template>

<script>
import req from '@/utils/request'
export default {
  data() {
    return {
      // 当前用户选择好的会员信息
      memberFormInfo: {},
      // 退费方式
      refundType: 1,

      remark: '',
      multipleSelection: [],
      curAmountStyle: 'curAmount',
      curAmountLabelStyle: 'curAmount_label',
      confirmDialogVisible: false
    }
  },
  created() {
  },
  methods: {
    // 提交
    async confirmHandle() {
      let rechargeNumbers = []
      this.multipleSelection.forEach(item => {
        rechargeNumbers.push(item.businessId)
      })
      const params = {
        deptId: this.$session.get('deptId'),
        phone: this.memberFormInfo.phone,
        refundReason: this.remark,
        rechargeNumbers
      }
      const { code, data } = await req.post('/member/wallet/recharge/rechargeRefund', params)
      if (code === 200) { 
        this.multipleSelection =[]
        let rechargeRefundNumbers =[]
        data && data.forEach(item => {
          rechargeRefundNumbers.push(item.rechargeRefundNumber)
        })
        this.dialogVisible = false
        this.confirmDialogVisible = false
        this.$emit('updateOrderNumHandle',rechargeRefundNumbers.join(','))
        this.$emit('showPaySuccessDialogHandle', 'refund')
      }

    },
    payWayFormatter(row) {
      return row.payWay == '3' ? '好码齐' : '现金'
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirm(){
      if(this.multipleSelection.length == 0){
        return this.$message.warning('请选择退费流水')
      }
      this.confirmDialogVisible = true
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    memberInfo: {
      type: Object,
      default() {
        return {
          memberName: null,
          sex: "0",
          year: null,
          month: null,
          phone: null,
        }
      }
    },
    accountList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    computedTotal() {
      let total = 0
      this.multipleSelection.forEach(item => {
        total = this.$bigNumber(total, '+', item.curAmount)
      })
      return total
    }
  },
  components: {
    CustomDialog: () => import('@/components/customDialog/CustomDialog')
  },
  watch: {
    memberInfo: {
      handler(newVal) {
        this.memberFormInfo = {
          ...newVal
        }
        this.multipleSelection = []
      },
      immediate: true,
    },
    value(newVal) {
      if (newVal) {
        this.remark = ''
      }
    }
  }
}

</script>

<style scoped lang='less'>
.header {
  padding: 16px;
  border-bottom: 1px solid #EBEAEE;
  background: #FEE4E3;

  .member-warp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0 !important;
    padding: 0 8px;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    background-color: #FFF6F5;
    border-radius: 4px 4px 4px 4px;
    color: #000;
  }
}

.content {
  padding: 16px;

  .content-price {
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;
    text-align: center;

    .price-icon {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .content-tips {
    margin: 10px;
    text-align: center;
  }

  .content-label {
    padding-top: 10px;
  }

  // 退费方式
  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #000;
  }

  /deep/ .el-radio__inner {
    width: 16px;
    height: 16px;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: transparent;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner::after {
    background-color: #1890ff;
    transform: translate(-50%, -50%) scale(2);
  }

  // 退费金额
  .content-amt {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    height: 36px;
    background: #F7F8F9;
    border-radius: 2px;
    border: 1px solid #D3D3D5;

    .label {
      width: 88px;
      height: 100%;
      line-height: 34px;
      border-right: 1px solid #D3D3D5;
      color: #000;
      text-align: center;
    }

    .value {
      margin-left: 10px;
    }
  }

  // 退款原因
  .content-remark {
    padding-top: 20px;
    width: 100%;

    /deep/ .el-input__inner,
    /deep/.el-input {
      width: 100%;
      height: 37px;
      max-width: 500px !important;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .footer_total {
    color: #667182;
    font-size: 14px;
    margin-right: 16px;
  }

  .footer_total_price {
    color: #000000;
    font-weight: 500;
  }

  /deep/.curAmount {
    background: #FFFBE8;
    color: #000000;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/.curAmount_label {
    background: #f0f1f3;
    font-weight: 400;
  }
  .tips{
    color: #FE8F1F;
    font-size: 12px;
    padding-left: 14px;
  }
}
</style>